<template>
    <div class="errors">
        <div class="ui red icon message" v-if="errors.length > 0">
            <i class="warning icon"></i>
            <div class="content">
                <div class="header">
                    <!-- 請處理以下錯誤 -->
                    {{ $t('ui.notifications.error.please_handle_errors') }}
                </div>
                <p v-for="(error, index) in errors">{{index + 1}}. {{error}}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        errors: Array
    },
    data: function () {
        return {
        }
    },
    mounted: function() {
    },
    computed: {
    },
    methods: {
    },
    components: {
    }
}
</script>

<style scoped>
</style>
